export const REQUESTING = 'REQUESTING';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const SET_NETWORK_STATUS = 'SET_NETWORK_STATUS';
export const REQUEST_REJECT = 'REQUEST_REJECT';
